export default __webpack_public_path__ + "static/media/newm.0d82fda3.png";